import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { applyListParams } from "../_shared";
import { decorateJob, jobsListSortMap, jobsSearchCols } from "./_helpers";

// returns: list of open job openings that start at least 30 minutes from now
export const open_jobs: Query<Ctx> = async ({ sb }, params) => {
  const cutoff = new Date(Date.now() + 30 * 60_000);
  const pad = (n: number) => n.toString().padStart(2, "0");
  const cutoffDate = `${cutoff.getFullYear()}-${pad(cutoff.getMonth() + 1)}-${pad(cutoff.getDate())}`;
  const cutoffTime = `${pad(cutoff.getHours())}:${pad(cutoff.getMinutes())}:${pad(cutoff.getSeconds())}`;

  let query = sb
    .from("v_jobs_list")
    .select("*")
    .eq("job_status", "open")
    .or(
      `start_date.gt.${cutoffDate},and(start_date.eq.${cutoffDate},start_time.gte.${cutoffTime})`,
    );
  query = applyListParams(query, params, {
    search: jobsSearchCols,
    sort: {
      map: jobsListSortMap,
      default: [
        { column: "start_date", ascending: true },
        { column: "start_time", ascending: true },
      ],
    },
  });
  const { data } = await query;
  if (!data) return [];
  return data.map(decorateJob);
};
